/**
 * The workspace-id-from-pathname contract, in one place.
 *
 * Three callers need it and must agree, because they run at different times in
 * the same page load: `useGenerationStore`'s persist `merge` (at module import,
 * before React renders), `GodotLayer` and `ForegroundLifecycleMount` (during
 * render). A drift between them shows up as the store hydrating settings for a
 * workspace the rest of the app doesn't think it is on.
 *
 * Deliberately pathname-based rather than `useParams` — two of the three callers
 * sit outside `<Routes>`, and one isn't a component at all.
 */

const WORKSPACE_PATH = /^\/workspace\/([^/]+)/;

/** The workspace id in a pathname, or undefined on a non-workspace route. */
export function workspaceIdFromPath(pathname: string): string | undefined {
  return pathname.match(WORKSPACE_PATH)?.[1];
}
